import(/* webpackMode: "eager" */ "/vercel/path0/apps/shopify-plugin/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/apps/shopify-plugin/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppInitializer"] */ "/vercel/path0/apps/shopify-plugin/src/components/AppInitializer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"display\":\"swap\",\"style\":[\"normal\"],\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"inter\"}");
